/*
  Dekogreen · medición del menú y del buscador (28-09-2026).

  Registra, sin tocar las direcciones y sin datos personales:
  - dk_menu_click: clic en un enlace del menú de escritorio o del cajón de móvil,
    con el apartado, el texto del enlace y la ruta de destino. En el menú nuevo,
    también el tipo (ver-todas, fila, foto, regla, elegida, apartado…).
  - dk_menu_abierto (menú nuevo, 29-09): lo envía dk-menu.js cuando un apartado sigue abierto
    0,7 s, una vez por apartado y página, con el modo (raton, clic, teclado o toque).
  - dk_cajon_abierto (29-09): se abre el cajón del móvil, con su origen (hamburguesa o barra).
  - dk_carrito_anadir (29-09): se añade algo al carrito, con el origen (ficha, coleccion…). Desde el B2, también la
    cantidad, las piezas, el formato y el producto, por los tres caminos: la ficha, la barra fija y la tarjeta.
  - dk_carrito_quitar (comité B2, 30-09): se quita una línea o se baja su cantidad, en el cajón o en el carrito, con la
    cantidad quitada, las piezas, el formato y el producto.
  - dk_whatsapp y dk_boletin_abierto (29-09): con su origen (cajon, menu o pagina). Quien se
    apunta al boletín abierto desde el cajón lleva además la etiqueta «origen-cajon».
  - dk_buscador_abierto: se abre el buscador de la cabecera o el del cajón (origen).
  - dk_buscador_resultado: clic en un resultado del buscador predictivo.
  - dk_buscador_enviado: se envía una búsqueda (solo la longitud, no el texto;
    las búsquedas en sí ya las recoge el informe de búsquedas de Shopify).

  Destinos:
  - Microsoft Clarity (app instalada): evento y etiquetas. La propia app gestiona
    el consentimiento de cookies.
  - Shopify.analytics.publish: evento propio que puede recoger un píxel
    personalizado (por ejemplo, para enviarlo a Google Analytics).

  Sirve de punto de partida antes de cambiar el menú (propuestas/2026-09-28-menu-estructura-v2.md).
*/
(function () {
  var pantallaMovil = window.matchMedia('(max-width: 989px)');

  function dispositivo() {
    return pantallaMovil.matches ? 'movil' : 'escritorio';
  }

  function ruta(href) {
    try {
      return new URL(href, window.location.href).pathname;
    } catch (e) {
      return '';
    }
  }

  function limpiar(texto) {
    return (texto || '').replace(/\s+/g, ' ').trim().slice(0, 60);
  }

  function enviar(nombre, datos) {
    datos.dispositivo = dispositivo();
    datos.pagina = window.location.pathname;
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(nombre, datos);
      }
    } catch (e) {}
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', nombre);
        Object.keys(datos).forEach(function (clave) {
          window.clarity('set', nombre + '_' + clave, String(datos[clave]));
        });
      }
    } catch (e) {}
  }

  // Dekogreen PRO (05-10, Conversión): la sesión de una cuenta de empresa, marcada en Clarity, sin nombre ni CIF. Clarity puede
  // cargar después que este fichero: se intenta ya y otra vez al terminar de cargar la página
  function marcarCuenta() {
    try {
      if (document.documentElement.getAttribute('data-dk-cuenta') === 'empresa' && typeof window.clarity === 'function') {
        window.clarity('set', 'dk_cuenta', 'empresa');
      }
    } catch (e) {}
  }
  marcarCuenta();
  window.addEventListener('load', marcarCuenta);

  // Área PRO (05-10): la vista, con el estado (empresa, particular o sin sesión), una vez al cargar
  window.addEventListener('load', function () {
    var raiz = document.querySelector('[data-dk-area-pro]');
    if (raiz) enviar('dk_area_pro', { estado: raiz.getAttribute('data-dk-area-pro'), accion: 'vista' });
  });

  // ─── Menú nuevo (plan 2, 29-09): <dk-megamenu data-dk-menu="escritorio"> y <dk-cajon data-dk-menu="movil"> ───
  // El apartado va en data-dk-apartado del botón, del panel, de la pantalla o del enlace directo.

  // Texto de un enlace sin el recuento ni la letra pequeña: «Monstera», no «Monstera7»
  function textoMenu(enlace) {
    var pieza = enlace.querySelector('.dk-fila__t, .dk-prow__t, .dk-mfila__t, .dk-mosaico__nombre, .dk-regla__nombre, .dk-elegida__nombre, .dk-persona__texto') || enlace;
    for (var n = pieza.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3 && n.nodeValue.trim()) return limpiar(n.nodeValue);
    }
    return limpiar(pieza.textContent);
  }

  function tipoMenu(enlace) {
    if (enlace.matches('.dk-panel__todas, .dk-fila--todas')) return 'ver-todas';
    if (enlace.matches('.dk-regla__planta')) return 'regla';
    if (enlace.matches('.dk-elegida')) return 'elegida';
    if (enlace.matches('.dk-mosaico__pieza--placa')) return 'placa';
    if (enlace.matches('.dk-mosaico__pieza')) return 'foto';
    if (enlace.matches('.dk-nav__boton, .dk-mfila')) return 'apartado';
    if (enlace.matches('.dk-boton1')) return 'presupuesto';
    if (enlace.matches('.dk-tramo')) return 'tramo';
    if (enlace.matches('.dk-tipo')) return 'tipo';            // 02-10: los tipos de Plantas en dos columnas (Conversión)
    if (enlace.matches('.dk-quien')) return 'quien-soy';
    if (enlace.matches('.dk-login')) return 'cuenta';
    return 'fila';
  }

  // Desde dónde se pulsa WhatsApp o el boletín
  function origenDe(el) {
    var menu = el.closest('[data-dk-menu]');
    if (!menu) return 'pagina';
    return menu.getAttribute('data-dk-menu') === 'movil' ? 'cajon' : 'menu';
  }

  // Quien se apunta al boletín abierto desde el cajón lleva además la etiqueta «origen-cajon»; desde otro sitio,
  // la de siempre
  function etiquetarBoletin(origen) {
    var campo = document.querySelector('#form__popup_newsletter input[name="contact[tags]"]');
    if (!campo) return;
    if (!campo.hasAttribute('data-dk-base')) campo.setAttribute('data-dk-base', campo.value);
    var base = campo.getAttribute('data-dk-base');
    campo.value = origen === 'cajon' ? base + ',origen-cajon' : base;
  }

  function apartadoDe(enlace) {
    var primerNivel = enlace.closest('.header__inline-menu .list-menu--inline > li');
    if (primerNivel) {
      var titulo = primerNivel.querySelector('.header__menu-item--top .label') || primerNivel.querySelector('.header__menu-item--top');
      return limpiar(titulo && titulo.textContent);
    }
    var submenu = enlace.closest('.menu-drawer__submenu');
    if (submenu) {
      var fila = submenu.closest('li');
      var tituloMovil = fila && fila.querySelector('.menu-drawer__menu-item');
      return limpiar(tituloMovil && tituloMovil.textContent);
    }
    return limpiar(enlace.textContent);
  }

  document.addEventListener('click', function (evento) {
    var objetivo = evento.target;
    if (!objetivo || typeof objetivo.closest !== 'function') return;

    if (objetivo.closest('.header__icon--search')) {
      enviar('dk_buscador_abierto', { origen: 'cabecera' });
      return;
    }
    if (objetivo.closest('[data-dk-abrir-buscador]')) {
      enviar('dk_buscador_abierto', { origen: 'cajon' });
      return;
    }

    // Área PRO (05-10): repetir, presupuesto, catálogo, entrar y solicitar, con el estado (empresa, particular o sin sesión).
    // No se corta aquí: el WhatsApp del área sigue contando también como dk_whatsapp (apartado «area-pro»)
    var accionArea = objetivo.closest('[data-dk-ap]');
    if (accionArea) {
      var raizArea = accionArea.closest('[data-dk-area-pro]');
      enviar('dk_area_pro', { estado: raizArea ? raizArea.getAttribute('data-dk-area-pro') : '', accion: accionArea.getAttribute('data-dk-ap') });
    }

    // Tramos (05-10, Marketing): el PDF de condiciones PRO, con el sitio (área, página o pregunta frecuente)
    var pdfPro = objetivo.closest('a[href*="/condiciones-pro"]');
    if (pdfPro) {
      var sitioPdf = pdfPro.getAttribute('data-dk-pdf') || (pdfPro.closest('.dkp-tiers__tramos') ? 'pagina' : pdfPro.closest('details, .accordion') ? 'pregunta' : 'otro');
      enviar('dk_pdf_pro', { sitio: sitioPdf });
      return;
    }

    var boletin = objetivo.closest('a[href="#dk-popup"], [data-dk-popup-open]');
    if (boletin) {
      var origenBoletin = origenDe(boletin);
      etiquetarBoletin(origenBoletin);
      enviar('dk_boletin_abierto', { origen: origenBoletin });
      return;
    }

    var enlace = objetivo.closest('a[href]');
    if (!enlace) return;

    // Dekogreen PRO (05-10, Conversión): entrar con la cuenta PRO desde la página de profesionales (portada o formulario)
    var entrarPro = enlace.closest('[data-dk-entrar-pro]');
    if (entrarPro) {
      enviar('dk_login_pro', { origen: entrarPro.getAttribute('data-dk-entrar-pro') || 'pagina' });
      return;
    }

    // WhatsApp aparte y sin el número: desde dónde y desde qué fila («Te contesto yo», «¿Un proyecto? Escríbeme»)
    if (/^https?:\/\/(wa\.me|api\.whatsapp\.com)\//.test(enlace.href)) {
      var zonaWhatsapp = enlace.closest('[data-dk-apartado]');
      enviar('dk_whatsapp', { origen: origenDe(enlace), apartado: zonaWhatsapp ? zonaWhatsapp.getAttribute('data-dk-apartado') : '', texto: textoMenu(enlace) });
      return;
    }

    var menuNuevo = enlace.closest('[data-dk-menu]');
    if (menuNuevo) {
      var zona = enlace.closest('[data-dk-apartado]');
      enviar('dk_menu_click', { menu: menuNuevo.getAttribute('data-dk-menu'), apartado: zona ? zona.getAttribute('data-dk-apartado') : '', enlace: textoMenu(enlace), destino: ruta(enlace.href), tipo: tipoMenu(enlace) });
      return;
    }

    if (enlace.closest('.header__inline-menu')) {
      enviar('dk_menu_click', { menu: 'escritorio', apartado: apartadoDe(enlace), enlace: limpiar(enlace.textContent), destino: ruta(enlace.href) });
    } else if (enlace.closest('#menu-drawer')) {
      enviar('dk_menu_click', { menu: 'movil', apartado: apartadoDe(enlace), enlace: limpiar(enlace.textContent), destino: ruta(enlace.href) });
    } else if (enlace.closest('predictive-search, .predictive-search')) {
      var fila = enlace.closest('.dk-ficha-fila, .dk-pin, .predictive-search__list-item');
      var lista = fila && fila.parentElement ? [].slice.call(fila.parentElement.children) : [];
      enviar('dk_buscador_resultado', { destino: ruta(enlace.href), tipo: enlace.closest('.dk-pin') ? 'coleccion' : (enlace.closest('.dk-ficha') ? 'ficha' : 'otro'), posicion: lista.indexOf(fila) + 1 });
    }
  }, true);

  // dk_menu_abierto lo envía dk-menu.js, que sabe cómo se abrió (ratón, clic, teclado o toque) y si siguió abierto.

  // Abrir el cajón del móvil, el de siempre o el nuevo, con su origen: la hamburguesa de la cabecera o «Menú» de la
  // barra inferior (que lo abre sin pasar por la hamburguesa)
  var origenCajon = 'otro';
  document.addEventListener('click', function (evento) {
    var objetivo = evento.target;
    if (!objetivo || typeof objetivo.closest !== 'function') return;
    if (objetivo.closest('mobile-dock [data-action="menu"]')) origenCajon = 'barra';
    else if (objetivo.closest('header-drawer summary')) origenCajon = 'hamburguesa';
  }, true);
  var cajon = document.querySelector('header-drawer details');
  if (cajon && typeof MutationObserver === 'function') {
    var cajonAbierto = cajon.hasAttribute('open');
    new MutationObserver(function () {
      var ahora = cajon.hasAttribute('open');
      if (ahora && !cajonAbierto) {
        enviar('dk_cajon_abierto', { origen: origenCajon });
        origenCajon = 'otro';
      }
      cajonAbierto = ahora;
    }).observe(cajon, { attributes: true, attributeFilter: ['open'] });
  }

  // Añadir al carrito, se haga desde donde se haga (ficha, packs, «comprados juntos», añadir rápido). Se lee la lista
  // de peticiones que ya lleva el navegador: la medición no toca las peticiones del carrito.
  function origenCarrito() {
    var p = window.location.pathname;
    if (/\/products\//.test(p)) return 'ficha';
    if (/\/collections\//.test(p)) return 'coleccion';
    if (/\/cart/.test(p)) return 'carrito';
    if (p === '/') return 'portada';
    return 'otro';
  }
  // Lo que se añade: la cantidad, las piezas, el formato y el producto (comités del 30-09). Se guarda al pulsar y se manda
  // con la petición buena, que es la que dice que se añadió de verdad. Tres caminos (comité B2): el formulario de la ficha y
  // el de la barra fija, que leen el selector de su propia sección, y el botón rápido de la tarjeta, que lleva sus datos.
  var ultimoAnadir = null;
  function datosDe(el, cantidad, producto) {
    return { t: Date.now(), cantidad: String(cantidad || '1'), uds: (el && el.getAttribute('data-dk-uds')) || '1',
      formato: (el && el.getAttribute('data-dk-formato')) || 'suelta', producto: (el && el.getAttribute('data-dk-producto')) || producto || '' };
  }
  document.addEventListener('submit', function (evento) {
    var f = evento.target;
    if (!f || typeof f.matches !== 'function' || !f.matches('form[action*="/cart/add"]')) return;
    var q = f.elements ? f.elements.namedItem('quantity') : null;
    // Plan C (menor 6 del B2): el producto sale del selector de la propia sección. Un formulario sin él (vista rápida,
    // comprados juntos, una ventana fuera de las secciones) va sin producto, nunca con el de la página. En las medidas sin
    // packs no hay selector: los datos van en la marca oculta data-dk-ficha (revisión final del plan C, 02-10).
    var seccion = f.closest('.shopify-section');
    ultimoAnadir = datosDe(seccion ? seccion.querySelector('[data-dk-oferta], [data-dk-ficha]') : null, q && q.value, '');
  }, true);
  document.addEventListener('click', function (evento) {
    var boton = evento.target && typeof evento.target.closest === 'function' ? evento.target.closest('add-to-cart') : null;
    if (boton) ultimoAnadir = datosDe(boton, 1);
  }, true);
  if (typeof PerformanceObserver === 'function') {
    try {
      new PerformanceObserver(function (lista) {
        lista.getEntries().forEach(function (peticion) {
          if (!/\/cart\/add(\.js)?(\?|$)/.test(peticion.name)) return;
          // Si el navegador da el código de respuesta, un error (400 o más) no cuenta
          if (typeof peticion.responseStatus === 'number' && peticion.responseStatus >= 400) return;
          var datos = { origen: origenCarrito() };
          if (ultimoAnadir && Date.now() - ultimoAnadir.t < 10000) {
            datos.cantidad = ultimoAnadir.cantidad; datos.uds = ultimoAnadir.uds; datos.formato = ultimoAnadir.formato;
            datos.producto = ultimoAnadir.producto;
            ultimoAnadir = null;
          }
          enviar('dk_carrito_anadir', datos);
        });
      }).observe({ type: 'resource' });
    } catch (e) {}
  }

  // Quitar del carrito (comité B2): el botón de quitar, o bajar la cantidad, en el cajón o en la página del carrito, con los
  // datos que lleva la línea (dk-linea-medicion.liquid). Al bajar, lo que baja; al quitar, la cantidad entera.
  function quitar(el, cantidad) {
    if (!(cantidad > 0)) return;
    enviar('dk_carrito_quitar', { origen: el.closest('mini-cart') ? 'cajon' : 'carrito', cantidad: String(cantidad),
      uds: el.getAttribute('data-dk-uds') || '1', formato: el.getAttribute('data-dk-formato') || 'suelta',
      producto: el.getAttribute('data-dk-producto') || '' });
  }
  document.addEventListener('click', function (evento) {
    var boton = evento.target && typeof evento.target.closest === 'function' ? evento.target.closest('cart-remove-button[data-dk-uds]') : null;
    if (boton) quitar(boton, parseInt(boton.getAttribute('data-dk-cantidad'), 10));
  }, true);
  document.addEventListener('change', function (evento) {
    var q = evento.target;
    if (!q || typeof q.matches !== 'function' || !q.matches('input[name="updates[]"][data-dk-uds]')) return;
    var antes = parseInt(q.defaultValue, 10), ahora = parseInt(q.value, 10);
    if (ahora < antes) quitar(q, antes - ahora);
    // Si se pulsa «−» dos veces antes de que el carrito se repinte, la segunda cuenta desde la primera
    q.defaultValue = q.value;
  }, true);

  document.addEventListener('submit', function (evento) {
    var formulario = evento.target;
    if (formulario && typeof formulario.matches === 'function' && formulario.matches('form[action*="/search"]')) {
      var campo = formulario.querySelector('input[name="q"]');
      enviar('dk_buscador_enviado', { longitud: campo ? campo.value.trim().length : 0 });
    }
  }, true);
  window.dkMedir = enviar;
})();
